import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSArticles($categorySize: Int) {
    localsearchCMSArticles(categorySize: $categorySize) {
      results {
        article {
          articleTitle
          urlSlug
          featureImageUrl
          wordCount
        }
      }
      categories {
        name
        featureImage
      }
    }
  }
`;

module.exports = query;
